import { HTTP } from "@/helpers/http-common"

const url = "/api/filetransaction"

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const disable = (data) => new Promise((resolve, reject) => {
  const { clave } = data;
  HTTP.delete(url, { params: { clave } }).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const download = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/getFile/${data}`, data, { responseType: "blob", timeout: 6000000 }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const errors = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/getErrors/${data}`, data, { responseType: "blob", timeout: 6000000 }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const exec = () => new Promise((resolve, reject) => {
  HTTP.put(`${url}/importer`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const retry = (data) => new Promise((resolve, reject) => {
  HTTP.get(`${url}/retry/${data}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  disable
  , list
  , download
  , errors
  , exec
  , retry
}


// WEBPACK FOOTER //
// ./src/services/filetransaction/importer/index.js